// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as FareEstimateOmsApiModel$PorterinFeature from "../api-model/FareEstimateOmsApiModel.mjs";

function apiModelToState(model) {
  return {
          request_id: model.callback_request_response.callback_request_id
        };
}

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(FareEstimateOmsApiModel$PorterinFeature.t_decode(json), "FareEstimateOmsEntityMapper.res");
  return {
          request_id: model.callback_request_response.callback_request_id
        };
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
